import { z } from 'zod'

import { StringDtoSchema } from '@hcr/api/shared'

import { LinkHeroDtoSchema } from '../common/LinkHeroDto'

export const HeroDtoSchema = z.strictObject({
  imageUrl: StringDtoSchema.url(),
  heading: StringDtoSchema,
  subHeading: StringDtoSchema,
  ingress: StringDtoSchema,
  cta1Copy: StringDtoSchema,
  cta1Link: LinkHeroDtoSchema,
  cta2Copy: StringDtoSchema.nullable(),
  cta2Link: LinkHeroDtoSchema.nullable(),
})

export type HeroDto = z.infer<typeof HeroDtoSchema>
